import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { apiService } from '@/services/api/apiService';
import { ReactNode } from 'react';

interface customSearchFoodScheduleSlice {
  menuDescription: ReactNode;
  menuTitle: any;
  spiceLevelName(spiceLevelName: any): unknown;
  packLevel: ReactNode;
  packUnit: string;
  areaCodeName: ReactNode;
  scheduledDate: ReactNode;
  kitchenName: ReactNode;
  deliveryEndTime: ReactNode;
  quantityAvailable: ReactNode;
  deliveryStartTime: ReactNode;
  mealTypeName: ReactNode;
  foodMenuName: string | undefined;
  imageUrl: string | undefined;
  specialMention: ReactNode;
  priceOverride: ReactNode;
  preorderClosingDatetime: string | number | Date;
  id: number;
  areaCodeId: number;
}

interface CustomSearchFoodSchedule {
  data: customSearchFoodScheduleSlice[];
  loading: boolean;
  error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const URL = import.meta.env.VITE_API_COOK_URL;

export const customSearchFoodSchedule = createAsyncThunk<
  customSearchFoodScheduleSlice[],
  {
    areaCodeId?: any;
    cookProfileId?: number;
    isForCustomer?: boolean;
    isActive?: boolean;
    scheduledDate?: any;
    cuisineTypeId?: any;
    weeklySchedule?: any;
  }, // both optional
  { rejectValue: string }
>('customSearchFoodSchedule/customSearchFoodSchedule', async (params, { rejectWithValue }) => {
  try {
    const config = { params };
    const response = await apiService.get<any>('custom_search_food_schedule', PORT, URL, config);
    return response.data.data;
  } catch (error: any) {
    return rejectWithValue(error.message || 'An error occurred');
  }
});

const initialState: CustomSearchFoodSchedule = {
  data: [],
  loading: false,
  error: null,
};

export const customSearchFoodScheduleSlice = createSlice({
  name: 'customSearchFoodSchedule',
  initialState,
  reducers: {
    clear: (state) => {
      state.data = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(customSearchFoodSchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        customSearchFoodSchedule.fulfilled,
        (state, action: PayloadAction<customSearchFoodScheduleSlice[]>) => {
          state.loading = false;
          state.data = action.payload;
        },
      )
      .addCase(customSearchFoodSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch food items';
      });
  },
});

export default customSearchFoodScheduleSlice.reducer;
export const { clear } = customSearchFoodScheduleSlice.actions;
